import { render, staticRenderFns } from "./questions-pro.vue?vue&type=template&id=0e8c7904&"
import script from "./questions-pro.vue?vue&type=script&lang=js&"
export * from "./questions-pro.vue?vue&type=script&lang=js&"
import style0 from "./questions-pro.vue?vue&type=style&index=0&id=0e8c7904&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports